import PropTypes from 'prop-types';
import React from 'react';
import Classnames from 'classnames';

import Icon from '../../common/icon/Icon';

require('./style.scss');

const ErrorScreen = props =>
  <div className="container-fluid">
    <div className="row">
      <div className="col-lg-24">
        <div className={Classnames('error-screen', { compact: props.compact })}>
          <div className="error-icon">{props.media}</div>
          <h1 className="error-title">{props.title}</h1>
          {props.actions ? <p>{props.actions}</p> : null}
          <p
            className="error-help-text"
            dangerouslySetInnerHTML={{ __html: props.helpText }}
          />

          {!props.compact ?
            <div className="error-play-store">
              <div>
                <a
                  href="https://play.google.com/store/apps/details?id=chotelal.mpaani.com.android.chotelal"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <img alt="Play Store" src="/static/images/app_download_icon.png" />
                </a>
              </div>
              <div>
                <p>Don&apos;t have Android phone?</p>
                <h3 className="error-play-store-number"><Icon name="phone" />&nbsp;022-33578387</h3>
              </div>
            </div> : null}
        </div>
      </div>
    </div>
  </div>;

ErrorScreen.propTypes = {
  actions: PropTypes.node,
  media: PropTypes.node,
  title: PropTypes.string,
  helpText: PropTypes.string,
  compact: PropTypes.bool,
};

module.exports = ErrorScreen;



// WEBPACK FOOTER //
// ./app/components/derived/error/ErrorScreen.jsx